module.exports = __webpack_public_path__ + "img/medalist_cv_tokyo2020-08_08_2021.2ca549e2.jpg";